// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"52":"05d83884","408":"57ec9101","590":"1ca59b6d","744":"ec9669e4","979":"68953656"}[chunkId] + ".chunk.css";
};